// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wJQ5","controls":"styles_controls__3n-aD","charLimit":"styles_charLimit__169g2","input":"styles_input__9_6xg","send":"styles_send__1l_7o"};